// src/hooks/useAiContext.js
import { useCallback, useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDoorloopjes } from '../context/DoorloopjesContext';
import { generateAiContext } from '../utils/aiContext';

/**
 * Returns a stable callback function `getContext` that the Chat SDK can call.
 * The callback will generate fresh context based on the current User and Location
 * at the moment it is called.
 */
export const useAiContext = () => {
  const { currentUser } = useDoorloopjes();
  const location = useLocation();
  
  // Use a ref to store the latest data. 
  // This allows us to access fresh data inside getContext without adding 
  // dependencies that would recreate the function.
  const dataRef = useRef({ user: currentUser, location });

  useEffect(() => {
    dataRef.current = { user: currentUser, location };
  }, [currentUser, location]);

  // Stable callback passed to PapChatLoader -> SDK
  const getContext = useCallback(async () => {
    return generateAiContext(dataRef.current);
  }, []);

  return getContext;
};